<template>
  <div></div>
</template>

<script>
export default {
  name: "AboutMeList",
};
</script>

<style lang="scss" scoped></style>
